import { render, staticRenderFns } from "./UserFamilyAdd.vue?vue&type=template&id=0922d012&"
import script from "./UserFamilyAdd.vue?vue&type=script&lang=js&"
export * from "./UserFamilyAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports